import Vue from 'vue'
import { mapState } from 'vuex'
import ImageLink from '@/components/image-link/image-link.vue'
import ContentDetailDialog from '@/components/content-modal/modal.vue'
import { updateBookmarksStatus } from '@/api/content'

export default Vue.extend({
  name: 'Content',
  components: {
    ImageLink,
    ContentDetailDialog
  },
  data () {
    return {
      showModal: false
    }
  },
  props: {
    content: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    handleClickContent () {
      this.$emit('click', this.content)
    },
    handleBookmark() {
      updateBookmarksStatus(this.content.id)
        .then(res => {
          this.content.is_bookmarked = !this.content.is_bookmarked
          window.location.reload()
        })
    },
    handleContentDetail() {
      this.showModal = true
    }
  }
})
